import type { GetFriendsAndFamilyResponse } from './types';

import { getGenericEndpoint } from './get.api';

export const getFriendsAndFamily = async (lang?: string) => {
    return await getGenericEndpoint<GetFriendsAndFamilyResponse>('friends-and-family', lang);
};

export const getFriendsAndFamilyFind = async (lang?: string) => {
    return await getGenericEndpoint<GetFriendsAndFamilyResponse>('friends-and-family/find', lang);
};

export const getFriendsAndFamilyNew = async (lang?: string) => {
    return await getGenericEndpoint<GetFriendsAndFamilyResponse>('friends-and-family/new', lang);
};
